import Column from '@components/Column';

import RadioButtonRow, { LabelValue } from './RadioButtonRow';

interface Props {
    value?: string;
    options: LabelValue[];
    onChange?: (v: string) =>void;
}

function RadioButton({ value, options, onChange }:Props) {
  return (<Column fullWidth spacing={12}>
        {options.map((option, index) => (
            <RadioButtonRow data={option}
                            key={`radio-button-${index}`}
                            value={value}
                            onChange={onChange} />
        ))}
    </Column>);
}

export default RadioButton;
